import { c as _c } from "react/compiler-runtime";
const InProcess = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M10.995 9H3V7h7.995L8.394 3.547 9.99 2.344 13.8 7.398l.453.602-.453.602-3.808 5.054-1.597-1.203L10.994 9Z" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default InProcess;